import React from 'react';
import { reportClientError } from '../utils/clientErrorReporter';

// A page that crashes while drawing shows this message instead of a blank screen, and the crash is reported
// (utils/clientErrorReporter.js). App.js keys it by the page path, so moving to another page starts fresh.
class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    reportClientError({
      kind: 'react',
      message: error?.message || String(error),
      stack: error?.stack || null,
      componentStack: info?.componentStack || null
    });
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div role="alert" style={{ padding: '32px 16px', maxWidth: 560, margin: '0 auto', textAlign: 'center' }}>
        <h2 style={{ marginBottom: 8 }}>Something went wrong on this page</h2>
        <p style={{ color: '#64748b', marginBottom: 16 }}>
          We've been notified. Reloading the page usually fixes it.
        </p>
        <button type="button" onClick={() => window.location.reload()}
          style={{ padding: '8px 18px', borderRadius: 6, border: 'none', background: '#1e3a5f', color: '#fff', cursor: 'pointer' }}>
          Reload page
        </button>
      </div>
    );
  }
}

export default AppErrorBoundary;
